import type { HeaderSchemaType } from '@vedalib/editor/lib/brand'
import styled, { css } from 'styled-components'

import { button } from 'components/Editor/styled/Button'
import type { ElementStyleCss } from 'services/Branding/types'

const floatingBurgerStyles = css`
  position: absolute;
  display: flex;
  width: 40px;
  height: 40px;
  top: 8px;
  align-items: center;
  justify-content: center;
  margin-right: 0;
  margin-left: 0;
  border-radius: 50%;
  background-color: var(--brand-primaryBackgroundColor);
  z-index: 1001; // more than the drawer
`

const positionRightStyles = css`
  right: 12px;
  left: auto;
  margin-right: 18px;
  margin-left: 24px;
  &.floatingButton {
    margin-right: 0;
  }
`

const positionLeftStyles = css`
  margin-right: 42px;
  margin-left: 18px;
  left: 12px;
`

export const MenuOpenIconStyled = styled.button<{
  $styles: ElementStyleCss<HeaderSchemaType>
  $isFloatingBurger?: boolean
  $positionRight?: boolean
}>`
  ${button}
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ $isFloatingBurger }) => $isFloatingBurger && floatingBurgerStyles}

  ${({ $positionRight }) => ($positionRight ? positionRightStyles : positionLeftStyles)}  

  ${({ $isFloatingBurger, $positionRight }) =>
    $isFloatingBurger &&
    $positionRight &&
    css`
      margin-right: 0;
    `}
`

export const CustomMenuStyled = styled.div`
  width: 24px;
  height: 24px;
  background-size: cover;
`
